import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "filter section" }
const _hoisted_2 = { class: "name header" }
const _hoisted_3 = {
  key: 0,
  class: "icon minimize",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  class: "path fill",
  x: "5",
  y: "11",
  width: "14",
  height: "2"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "icon add plus more",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  class: "path fill",
  d: "M11 5V11H5V13H11V19H13V13H19V11H13V5H11Z"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "options col"
}
const _hoisted_10 = { class: "check" }
const _hoisted_11 = ["id", "value"]
const _hoisted_12 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "row name",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.filterExpanded = !$setup.filterExpanded))
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString($props.filterName), 1),
      ($setup.filterExpanded)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
    ]),
    ($setup.filterExpanded && $props.options)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "option row",
              key: option
            }, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: option,
                  value: option,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedOptions) = $event))
                }, null, 8, _hoisted_11), [
                  [_vModelCheckbox, $setup.selectedOptions]
                ])
              ]),
              _createElementVNode("label", { for: option }, _toDisplayString(option), 9, _hoisted_12)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}